/*
 * User Module
 *
 * @author: Elton Jain
 */
/* global define, require */

define('User',[
    'jquery',
    'UI',
    'modules/common/Constants',
    'Helper',
    'Config'
], function($, UI, Constants, Helper, Config) {
    'use strict';

    var User = {
        init: function() {
            this.bindEvents();
        },
        bindEvents: function() {
            var base = this,
                currentPage = Config.get('page.route'),
                objImageForm = {};

            // Update Profile
            UI.$b.on('submit', '#frmUserProfile', function() {
                var f = this,
                    $f = $(f),
                    api = $f.attr('action');

                if (!$.trim(f.fullname.value)) {
                    alert('Please enter your name');
                    return false;
                }

                $.post(api, $f.serialize(), function(response) {
                    // console.log(response);
                    if (response.status === true) {

                        require(['Mixpanel'], function(MixPanel) {
                            MixPanel.hit('edit_profile', {});
                        });
                        window.location.href = '/profile';
                    } else {
                        alert(response.message);
                    }
                });

                return false;
            });

            // User Follow / Unfollow
            UI.$b.off('click', '.btn-follow').on('click', '.btn-follow', function() {
                var $btn = $(this),
                    userId = $btn.data('id'),
                    isFollowing = $btn.is('.following') ? true : false,
                    langs = Config.get('lang'),
                    buttonText = (isFollowing) ? langs.follow_btn : langs.following,
                    btn_action = $btn.hasClass('btn-mini-action');

                // Unfollow
                base.followUser(userId, !isFollowing, function() {
                    $btn.text(buttonText);
                    if(!isFollowing) {
                        if(btn_action) {
                            $btn.addClass('following').removeClass('btn-blue');    
                        } else {
                            $btn.addClass('following')
                        }
                        
                    } else {
                        if(btn_action) {
                            $btn.removeClass('following').addClass('btn-blue');
                        } else {
                            $btn.removeClass('following');
                        }
                        
                    }
                });
                return false;
            });

            base.pageUserProfile();
            base.pageEditProfile();

        },

        followUser: function(followUserId, doFollow, callback) {
            var api = '/user/follow',
                unfollowApi = '/user/unfollow',
                apiData = {},
                eventType = 'Follow';

            if (!followUserId) {
                alert('Invalid request');
            }

            apiData.followingId = followUserId;

            doFollow = doFollow ? true : false;

            if (doFollow === false) {
                // UnFollow
                api = unfollowApi;
                eventType = 'Unfollow';
            }

            $.post(api, apiData, function(response) {
                // console.log(response);
                if (response.status === true) {

                    if (callback) {
                        callback();
                    }

                    require(['Mixpanel'], function(MixPanel) {
                        MixPanel.hit('follow_profile', {'event': eventType});
                    });

                } else {
                    if (response.status_code == Constants.status_code.no_auth_login) {
                        require(['Auth'], function(Auth) {
                            Auth.showLoginPopup(true, {source: 'user follow'});
                        });
                    } else {
                        alert(response.message);
                    }
                    return false;
                }
            });

        },
        pageEditProfile: function () {
            if (Config.get('page.route') === 'user.edit') {
                require(['ImageForm', 'Toastr', 'Validation'], function(ImageForm, Toastr, Validation) {
                    var elEditFormId = '#formEditProfile',
                        objImageForm = new ImageForm({
                            elForm: elEditFormId,
                            elFileSelect: '#elUploadPic',
                            elSelectTrigger: '#elProfilePic',
                            elPreviewContainer: '#elProfilePic',
                            maxImages: 1,
                            useContainerSelf: true
                        });

                    UI.$b.on('submit', elEditFormId, function(ev) {
                        ev.preventDefault();

                        var validation = new Validation({
                            form: $(this),
                            allConstraints: {
                                fullname: {
                                    presence: {
                                        message: '^Name cannot be empty'
                                    },
                                    length : {
                                        minimum: 3,
                                        tooLong: '^Too short name'    
                                    }
                                },
                                tagline: {
                                    length : {
                                        maximum: 40,
                                        tooLong: '^Bio cannot exceed %{count} characters'    
                                    }
                                },
                                social_fb: {
                                    url: {
                                        message: '^Facebook link is incorrect'
                                    }
                                },
                                social_google: {
                                    url: {
                                        message: '^Google plus link is incorrect'
                                    }
                                },
                                website: {
                                    url: {
                                        message: '^Website link is incorrect'
                                    }
                                },
                                description: {
                                    length : {
                                        minimum: 25,
                                        tooShort: '^Description is too short'
                                    }
                                }
                            }
                        });


                        if (validation.isValid() !== true) {
                            return;
                        }

                        var $form = $(this),
                            images = objImageForm ? objImageForm.getImages() : null,
                            formData = $.extend($form.serializeArray(), {}),
                            _fd = new FormData();

                        $form.find('[type=submit]').addClass('loading');

                        $.each(images, function(i, file) {
                            _fd.append('image' + i, file);
                        });

                        $.each(formData, function(i, input) {
                            _fd.append(input.name, input.value);
                        });

                        $.ajax({
                            url: '/ajax/user/updateProfile',
                            data: _fd,
                            processData: false,
                            contentType: false,
                            type: 'POST',
                            success: function(response) {
                                $form.find('[type=submit]').removeClass('loading');

                                if (response.status === true) {
                                    new Toastr({
                                        message: response.message
                                    });

                                    setTimeout(function(){ window.location.reload(); }, 1000);

                                } else {
                                    new Toastr({
                                        message: response.message,
                                        'icon': 'ion-alert',
                                        'class': 'toastr-error'
                                    });
                                }
                            },
                            error: function() {
                                $form.find('[type=submit]').addClass('loading');
                            }
                        });
                        return false;
                    });
                });
            }

        },
        pageUserProfile: function() {
             // && $elProfileTabs.is('.enabled')
            if(Config.get('page.route') === 'user.profile') {

                // Expand more info on Expert profile
                var $elUserProfileMoreContent = $('#userMoreContentWrap'),
                    $btnViewMoreProfile = $('#btnViewMoreProfile');
                $btnViewMoreProfile.on('click', function () {
                    $btnViewMoreProfile.toggleClass('open');
                    $elUserProfileMoreContent.toggleClass('open');
                });

                // Click on profile tabs
                var $elProfileTabs = $('#usrProfileTabs'),
                    $elProfileTabsContainer = $('#usrProfileTabContainer'),
                    PROFILE_USER_ID = $elProfileTabs.data('id'),
                    actions = {
                        all: {
                            api: '/ajax/user/activities',
                            template: 'tplUserActivity',
                            containerId: 'userActivityList',
                            elLazyButtonId: 'btnLoadMoreActivity',
                            elNoResultsId: 'noresultsall'
                        },
                        questions: {
                            api: '/ajax/user/questions',
                            responseKey: 'questions',
                            template: 'tplUserActivity',
                            containerId: 'userQuestionList',
                            elLazyButtonId: 'btnLoadMoreQuestions',
                            elNoResultsId: 'noresultqs'
                        },
                        answers: {
                            api: '/ajax/user/answers',
                            responseKey: 'answers',
                            template: 'tplUserActivity',
                            containerId: 'userAnswerList',
                            elLazyButtonId: 'btnLoadMoreAnswers',
                            elNoResultsId: 'noresultans'
                        },
                        followers: {
                            api: '/ajax/user/followers',
                            responseKey: 'followers',
                            template: 'tplUserInvite',
                            containerId: 'userFollowerList',
                            elLazyButtonId: 'btnLoadMoreFollowers',
                            elNoResultsId: 'noresultflr'
                        },
                        followings: {
                            api: '/ajax/user/followings',
                            responseKey: 'followings',
                            template: 'tplUserInvite',
                            containerId: 'userFollowingList',
                            elLazyButtonId: 'btnLoadMoreFollowings',
                            elNoResultsId: 'noresultflg'
                        },
                        photobooth: {
                            api: '/ajax/booth/user/get',
                            template: 'tplBoothView',
                            containerId: 'userPhotoboothList',
                            elLazyButtonId: 'btnLoadMorePhotbooth',
                            elNoResultsId: 'noresultpb'
                        }
                    };

                $elProfileTabs.on('click','li', function() {
                    var $tab = $(this),
                        action = $tab.data('name'),
                        tabData = actions[action] || null;

                    if(!tabData || $tab.is('.active')) {
                        return false;
                    }

                    $tab.addClass('active').siblings('li').removeClass('active');
                    var $currentTabContainer = $elProfileTabsContainer.children('.tab-content[data-name="'+action+'"]');
                    $currentTabContainer.addClass('active').siblings().removeClass('active');

                    if($currentTabContainer.is('._loaded')) {
                        return true;
                    }

                    require(['DataList', 'JSTemplate', 'Auth'], function(DataList, template, Auth) {
                        var dataList = new DataList();
                        // $('#userActivityList,#btnLoadMoreActivity').addClass('hidden');
                        // $('#tabInfoCont,#switchActivityId').removeClass('hidden');
                        // $('#tabInfo').html('');

                        dataList.init({
                            containerId: tabData.containerId,
                            template: tabData.template,
                            useApi: true,
                            useApiAsData: true,
                            api: tabData.api,
                            lazyLoad: true,
                            elLazyButtonId: tabData.elLazyButtonId,
                            rpp: 10,
                            elNoResultsId: tabData.elNoResultsId,
                            apiData: {
                                userId: PROFILE_USER_ID,
                                page: 1,
                                whichUser: PROFILE_USER_ID
                            },
                            customFuseField: tabData.responseKey || null
                        });
                        $currentTabContainer.addClass('_loaded');
                    });
                });

                if($elProfileTabs.is('.expert')) {
                    $elProfileTabs.children('li').eq(2).trigger('click');
                } else {
                    $elProfileTabs.children('li:first-child').trigger('click');
                }
                
            }
        }
    };

    return User;
});
